module.exports = __webpack_public_path__ + "static/media/landing-person-background.57b04514.png";